export default __webpack_public_path__ + "static/media/flag-czech-republic.72c3ba70.svg";